/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cruitive_Update_RefreshInputs */



/**
* | output |
* | --- |
* | "Cruitive has been updated and to display the page you are trying to access, you need to refresh your browser. Click \"Reload page\" below or do it directly in ..." |
*
* @param {Cruitive_Update_RefreshInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const cruitive_update_refresh = /** @type {((inputs?: Cruitive_Update_RefreshInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cruitive_Update_RefreshInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Cruitive has been updated and to display the page you are trying to access, you need to refresh your browser. Click \"Reload page\" below or do it directly in the browser.")
	return /** @type {LocalizedString} */ ("Cruitive har uppdaterats och för att visa den sidan du försöker komma åt behöver du uppdatera webbläsaren. Klicka på \"Ladda om sidan\" nedan eller gör det direkt i webbläsaren.")
});